import gql from 'graphql-tag'

export const GENERAL_REPORT = gql`
    query($input: GeneralReportInput!) {
        generalReport(input: $input)
    }
`
